import styled from '@emotion/styled';
import { css } from '@emotion/react';
const carouselItemPaddingPartialCSS = ({ theme, stretched, }) => {
    if (stretched)
        return css `
      padding: 0;
    `;
    const paddingYValue = theme.device === 'mobile' ? theme.space[5] : theme.space[4];
    return css `
    padding: ${paddingYValue} 0;
  `;
};
const carouselItemStatePartialCSS = ({ theme, isActive, light, }) => {
    const color = light
        ? theme.mode === 'light' ? theme.colors.text : theme.colors.backgrounds.heading.text[0]
        : theme.colors.backgrounds.primaryNavigation.text[0];
    return css `
    &:hover,
    &:active {
      color: ${color};
    }

    ${isActive &&
        `
      color: ${color};
      position: relative;
      &::after {
        content: '';
        height: 0;
        width: 100%;
        margin-bottom: -1px;
        border-bottom: 1px solid ${color};
      }
    `}
  `;
};
const StyledCarouselItem = styled.li `
  box-sizing: border-box;
  align-items: center;
  display: flex;
  flex: 1 0 auto;
  height: inherit;
  white-space: nowrap;
  font-size: ${({ theme }) => theme.fontSizes[theme.device === 'mobile' ? 2 : 1]};
  line-height: ${({ theme }) => theme.lineHeights[1]};
  margin: 0 ${({ theme }) => theme.space[3]};
  flex-direction: column;
  justify-content: center;
  color: ${({ theme, light }) => light
    ? theme.mode === 'light' ? theme.colors.backgrounds.content.text[1] : theme.colors.backgrounds.heading.text[1]
    : theme.colors.backgrounds.primaryNavigation.text[1]};
  cursor: pointer;

  ${carouselItemStatePartialCSS}
  ${carouselItemPaddingPartialCSS}
  ${({ customStyles }) => customStyles}

  ${({ tapHighlight }) => !tapHighlight && '-webkit-tap-highlight-color: rgba(0, 0, 0, 0);'};
`;
export default StyledCarouselItem;
